import * as React from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const ViewPassword = ({setUpdatePasswordMode}) => {
    const {mode} = useDarkMode();
    return (
        <Box sx={{backgroundColor:mode.settings.cardBackgroundColor, borderRadius:1, padding:'20px'}}>
            <Stack flexWrap={"wrap"}>
                <Stack direction={'row'} justifyContent={'space-between'} flexWrap={"wrap"}>
                    <Typography variant={'subtitle7'} color={mode.settings.textColor3} width={{xs : '100%'}}>Sécurité</Typography>
                </Stack>
                <Typography variant={"body2"} component="span" color={mode.settings.textColor3}>Changer le mot de passe</Typography>
                <Stack direction={'row'} alignItems={"center"} flexWrap={"wrap"}>
                    <img src={'/assets/icon/key.png'} alt={'Mot de passe'} className={'profile-icon'}/>
                    <Typography color={mode.settings.textColor3}>Nous vous conseillons d’utiliser un mot de passe sûr que vous n’utilisez nulle part ailleurs</Typography>
                </Stack>
                <Button className="btn" onClick={() => setUpdatePasswordMode(true)} sx={{width : '300px', alignSelf: "end", marginTop: '15px'}}>
                    <img src={'/assets/icon/edit-.png'} alt={'Modifier mot de passe'} style={{marginRight:'10px'}}/>
                    <Typography variant={"subtitle3"} component="span">Modifier mon mot de passe</Typography>
                </Button>
            </Stack>
        </Box>
    )
}

export default ViewPassword;
